import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import ReactDOM from 'react-dom/client';
import App from "./App";
import { msalConfig } from './Auth/AuthConfig';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './Redux/Store';
import { initializeAgGrid } from './Utils/AgGridSetup';

const pca = new PublicClientApplication(msalConfig);
initializeAgGrid();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <MsalProvider instance={pca}>
    <Provider store={store}>
    <App />
    </Provider>
  </MsalProvider>
);

reportWebVitals();
